import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { SectionBase } from '../../../content-composer/section-base/section-base';
import type { ToolbarView } from './types';

type Props = {
  setView: (view: ToolbarView) => void;
};

export const DefaultToolbar = ({ setView }: Props) => {
  const { t } = useTranslation('content-composer');

  return (
    <SectionBase.Toolbar.Button onClick={() => setView('options')}>
      <Icon name='plus-small' css={{ marginRight: theme.spacing(0.5) }} />
      {t('Add Link')}
    </SectionBase.Toolbar.Button>
  );
};
